// var configEnv = "development";
// var configEnv = "staging";
// var configEnv = "stagingJC2";
//var configEnv = "production";


var configEnv = process.env.REACT_APP_NODE_ENV;
if (!["development", "staging", "production"].includes(configEnv)) {
  throw new Error(`Invalid REACT_APP_NODE_ENV value: ${configEnv}`);
}
var config = {
  //##########Live config##########
  production: {
    appUrl: "https://jokercasino.com",
    apiUrl: "https://api.jokercasino.com/api/v1",
    staticUrl: "https://api.jokercasino.com/api/v1",
    liveChatUrl:
      "https://missioncontrol9.jokercasino.com/public/livechat/php/app.php?widget-inline",
    fileSourceUrl: "https://missioncontrol9.jokercasino.com/public",
    socketUrl: "wss://api.jokercasino.com:7002",
    debug: false,
    onRamperApiKey: "", //DO not copy, only for blizzcasino
    payOpPublicKey: "",
  },

  //#########Stage config##########
  staging: {
    appUrl: "https://jc.cbstagings.com",
    apiUrl: "https://jcapi.cbstagings.com/api/v1",
    staticUrl: "https://jcapi.cbstagings.com/api/v1",
    publicDir: "https://jcboss.cbstagings.com/public",
    liveChatUrl:
      "https://jcboss.cbstagings.com/public/livechat/php/app.php?widget-inline",
    FBAppId: "1172568450039492",
    GoogleClientId:
      "790397384946-mk49403chl2iojqcvin3a303kt2umult.apps.googleusercontent.com",
    debug: false,
  },

  //#########Stage config##########
  stagingJC2: {
    appUrl: "https://jc2.chimptestserver.com",
    apiUrl: "https://jc2api.chimptestserver.com/api/v1",
    staticUrl: "https://jc2api.chimptestserver.com/api/v1",
    liveChatUrl:
      "https://jc2bossoffice.chimptestserver.com/public/livechat/php/app.php?widget-inline",
    fileSourceUrl: "https://jc2bossoffice.chimptestserver.com/public",
    socketUrl: "wss://jc2api.chimptestserver.com:7002",
    debug: false,
    onRamperApiKey: "", //DO not copy, only for blizzcasino
    payOpPublicKey: "", //Its the production key, there is no staging
  },

  //##########Local config##########
  development: {
    appUrl: "http://localhost",
    apiUrl: "http://casinoapi.local.host/api/v1",
    staticUrl: "http://casinoapi.local.host/api/v1",
    liveChatUrl:
      "http://casinoadmin.local.host/public/livechat/php/app.php?widget-inline",
    fileSourceUrl: "http://casinoadmin.local.host/public",
    socketUrl: "ws://localhost:7002",
    debug: true,
    onRamperApiKey: "", //DO not copy, only for blizzcasino
    payOpPublicKey: "", //Its the production key, there is no staging
  },
};

var finalConfig = config[configEnv];

finalConfig.defaultLanguage = {
  code: "en",
  language: "English",
  flag_path: finalConfig.fileSourceUrl + "/images/flags/svg/gb.svg",
};

export default finalConfig;
